import {serverFetchDataResult} from './serverFetch';
import serverPost from './serverPost';

// search and pass a list of objects in the callack function handleReply
export const search = (tableName, value, handleReply) =>
{
    JSON.stringify('XXXXVALUE=' + value)
    const searchValues = value?value:{}
    let url = ''
    let args =""
    Object.entries(searchValues).map(it=> {
        if (it[1]) {
            args += '&'
            args += it[0] +  '=' + it[1]
        }
    })
    if (tableName) {
        url = '/fetchRows?tableName=' + tableName + args
    } else {
        alert('No table name')
    }    

    const handleFetchDataResult = list => {
        if (list.length !== 0) {
            if (!!handleReply) {
                handleReply(list)
            }    
        } else {
            handleReply([])
        }   
    }

    //alert('search link:' + JSON.stringify(link))
    serverFetchDataResult(url, handleFetchDataResult)
}        

// search 2 is a post search where the value consists of a number of search variables
export const search2 = (tableName, value, handleReply) =>
{
    const url = '/fetchRows2'
    const data = {
        tableName,
        value, 
    }

    const handleReplySearch2 = data => {
        //alert('search2 result list=' + JSON.stringify(list))
        if (data.status === 'OK') {
            const list = data.result
            handleReply(list)
        } if (data.status ==='WARNING') {
            const list = data.result
            const defaultMessage = 'WARNING: data contains no message. data:' + JSON.stringify(data)
            const message = data.message?data.message:defaultMessage
            alert(message)
            handleReply(list)
        }
    } 

    //alert('search2 data:' + JSON.stringify(data))
    serverPost(url, data, handleReplySearch2)
}        
